import { count } from "@components/config/helpers";
import ToggleButton from "@mui/material/ToggleButton"
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup"

const ProductToggleButtons = (props) => {
    const {
        alignment,
        handleToggleChange,
        product_description_long,
        product_description_short,
        faqs,
        measurements,
        articles,
        videos,
        reviews
    } = props;
    

    return (
        <ToggleButtonGroup
            sx={{
                width:'max-content',
                // border: '1px solid var(--color-primary)',
                '&  .MuiToggleButton-root.Mui-selected':{
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    ':hover': {
                        backgroundColor: 'primary.main',
                        color: 'primary.contrastText',
                    },
                },
                '& .MuiToggleButton-root':{
                    color: 'primary.main',
                }
            }}
            value={alignment}
            exclusive
            onChange={handleToggleChange}
            aria-label="Platform"
        > 

            {product_description_short && product_description_long && (
                <ToggleButton  value={'description'}  sx={{border: '1px solid var(--color-primary)'}}>
                    Description
                </ToggleButton>
            )}
            {faqs && count(faqs) > 0 && (
                <ToggleButton   value={'faq'}  sx={{border: '1px solid var(--color-primary)'}}>FAQ</ToggleButton>
            )}
            {measurements && count(Object.keys(measurements)) > 0 && (
                <ToggleButton   value={'measurements'}  sx={{border: '1px solid var(--color-primary)'}}>{"Measurements & Spec"}</ToggleButton>
            )}
            {articles && count(articles) > 0 &&  (
                <ToggleButton   value={'related_articles'}  sx={{border: '1px solid var(--color-primary)'}}>Related Articles</ToggleButton>
            )}
            {videos && count(videos) > 0 &&  (
                <></>
            )}
            {reviews && count(reviews) > 0 &&   (
                <ToggleButton   value={'reviews'}  sx={{border: '1px solid var(--color-primary)'}}>Reviews</ToggleButton>
            )}

        </ToggleButtonGroup>
    )
}

export default ProductToggleButtons